import { css } from "styled-components";

const BodyStyle = css`
  font-family: ${({ theme }) => theme.fonts.graphik};
  color: ${({ theme }) => theme.colors.gray1200};
  line-height: 130%;
  font-size: 1rem;
  ${({ theme }) => theme.media.tabletUp`
    line-height: 140%;
    font-size: 1.125rem;
  `};
`;

export default BodyStyle;
